import { useTheme } from '@emotion/react';

import Accordion from '~/common/components/Accordions/Accordion';
import AccordionButton from '~/common/components/Accordions/AccordionButton';
import AccordionIcon from '~/common/components/Accordions/AccordionIcon';
import AccordionItem from '~/common/components/Accordions/AccordionItem';
import AccordionPanel from '~/common/components/Accordions/AccordionPanel';
import Box from '~/common/components/Box';
import HStack from '~/common/components/Stacks/HStack';
import Text from '~/common/components/Texts/Text';
import { formatCurrency } from '~/common/util/format';
import FormulaBreakdown from '~/pages/RentalIncome/RentalIncomeCalculation/ReviewBreakdown/FormulaBreakdown';

import RentalCalculationReviewBreakdown from '../model/RentalCalculationReviewBreakdown';

type Rental998Props = {
  data?: RentalCalculationReviewBreakdown;
  pitia?: number;
  formulas?: any;
  hideAccordion?: boolean;
};

const Rental998 = ({
  formulas,
  data,
  pitia,
  hideAccordion = false,
}: Readonly<Rental998Props>) => {
  const theme = useTheme();

  if (!data) {
    return null;
  }

  const adjustedPITIA = formatCurrency(data.getAdjustedPITIA());
  const positiveIncome = formatCurrency(data.getPositiveNetRentalIncome());

  return (
    <Box>
      {hideAccordion && (
        <Box pl="1rem">
          <FormulaBreakdown formulas={formulas} />
        </Box>
      )}
      {!hideAccordion && (
        <Accordion allowToggle defaultIndex={[0]} mt={8}>
          <AccordionItem
            background={theme.colors?.gray[50]}
            border={`1px solid ${theme.colors?.gray[200]}`}
          >
            <AccordionButton>
              <Box
                flex="1"
                textAlign="left"
                as="h3"
                fontSize="1.125rem"
                fontWeight="500"
              >
                Operating Income Statement 998 Review Breakdown
              </Box>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel p={4} mt="2px" background={theme.colors?.white}>
              <FormulaBreakdown formulas={formulas} />
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      )}
      <Box mt={8} bg="#FAFAFA" padding={{ sm: '20px', md: '20px' }}>
        <Text fontSize="1rem" fontWeight="500">
          Form 998:
        </Text>
        <HStack>
          <Text fontSize="0.875rem" fontWeight="500">
            Adjusted PITIA:
          </Text>
          <Text fontSize="0.875rem" fontWeight="400">
            {!!pitia && `${formatCurrency(pitia)} to `}
            {adjustedPITIA}
          </Text>
        </HStack>
        <HStack>
          <Text fontSize="0.875rem" fontWeight="500">
            Positive Net Rental Income:
          </Text>
          <Text fontSize="0.875rem" fontWeight="400">
            {positiveIncome}
          </Text>
        </HStack>
      </Box>
    </Box>
  );
};

export default Rental998;
